module.exports = __webpack_public_path__ + "img/logo_xavier@1.5x.a1328494.png";